import React, { FC } from "react";
import { Text } from "./Text";
import { makeStyles, Button } from "@material-ui/core";
import colors from "../constants/colors";

interface INextButtonProps {
  text?: string;
  onClick?: () => void;
  disabled?: boolean;
}

export const NextButton: FC<INextButtonProps> = ({
  text = "NEXT",
  onClick,
  disabled = false,
}) => {
  const classes = styles();
  return (
    <Button
      disabled={disabled}
      className={classes.button}
      onClick={() => (onClick ? onClick() : {})}
    >
      <Text bold={true}>{text}</Text>
      <svg
        className={classes.triangle}
        width={10}
        height={19}
        viewBox="0 0 9.49 18.452"
      >
        <path fill={colors.primary} d="M.007.153l.311 18.295L9.331 8.95z" />
      </svg>
    </Button>
  );
};

const styles = makeStyles(() => ({
  button: {
    display: "flex",
    alignItems: "center",
  },
  triangle: {
    margin: "0px 10px",
    position: "relative",
    top: -1,
  },
}));
